import { createContext, useContext } from "react";

interface WebViewContext {
    isWebView: boolean | undefined;
    setIsWebView: (state: boolean) => void;
    isRedirectToWelcomeScreen: boolean | undefined;
    setIsRedirectToWelcomeScreen: (state: boolean) => void;
    isRedirectToRegIdentificationScreen: boolean | undefined;
    setIsRedirectToRegIdentificationScreen: (state: boolean) => void;
}

export const defaultWebViewContext: WebViewContext = {
    isWebView: false,
    setIsWebView: () => undefined,
    isRedirectToWelcomeScreen: false,
    setIsRedirectToWelcomeScreen: () => undefined,
    isRedirectToRegIdentificationScreen: false,
    setIsRedirectToRegIdentificationScreen: () => undefined,
};

export const webViewContext = createContext<WebViewContext>(defaultWebViewContext);

export const useWebViewContext = (): WebViewContext => {
    return useContext(webViewContext);
};
